import React from "react";
import { Dialog } from "@material-ui/core";
import { CloseIcon } from "../../../../../assets/Icons";
import { styles } from "./styles";
import { AppStrings } from "../../../utils";

interface Props {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const LoanDisbursementModal: React.FC<Props> = ({ open, onYes, onNo }) => {
  return (
    <Dialog open={open}>
      <div className={styles.container}>

        <div className={styles.header.container}>
          <div className={styles.header.title}>{AppStrings.LOAN_DISBURSEMENT.HEADER}</div>
          <CloseIcon className={styles.header.closeIcon} onClick={onNo} />
        </div>

        <span className={styles.message.title}>
          {AppStrings.LOAN_DISBURSEMENT.TITLE}
        </span>

        <span className={styles.message.subText}>
          {AppStrings.LOAN_DISBURSEMENT.DESCRIPTION}
        </span>

        <div className={styles.buttons.container}>
          <button className={styles.buttons.yes} onClick={onYes}>{AppStrings.BUTTON.YES}</button>
          <button className={styles.buttons.no} onClick={onNo}>{AppStrings.BUTTON.NO}</button>
        </div>

      </div>
    </Dialog>
  );
};
